import { UsuarioSymbol } from '../../../components/layout/UsuarioSymbol'
import { useSelector } from 'react-redux'
import { selectUsuarioActual } from '../../../redux/slices/autenticacion/autenticacion.slice'
import { AppMapas } from '../../../utils/Constantes'
import { DivisionDeNegocioOpcion } from '../../usuarios/models'

export const DatosUsuario = () => {
  const usuarioActual = useSelector(selectUsuarioActual)

  return (
    <>
      <div className='d-flex align-items-center p-2 w-100 card-rounded'>
        <UsuarioSymbol
          nombre={usuarioActual?.nombre!}
          primerApellido={usuarioActual?.apellidoPaterno}
          perfil={usuarioActual?.perfil!}
          tamaño='45px'
          bullet={false}
          estatus={true}
          margenFinal='me-2'
        />
        <div className='row w-100 justify-content-between'>
          <div className='col'>
            <div className='fw-bold'>{`${usuarioActual?.nombre} ${usuarioActual?.apellidoPaterno}`}</div>
            <div className='fw-bold text-muted text-hover-primary fs-7'>{usuarioActual?.email}</div>
            <div className='fs-7 text-break'>
              Divisiones de negocio:{' '}
              {usuarioActual?.divisionesNegocio
                .map((dn: DivisionDeNegocioOpcion) => {
                  return dn.descripcion
                })
                .join(', ')}
            </div>
          </div>
          <div className='mx-0 px-0 col-md-auto d-flex justify-content-end'>
            <div className='d-flex align-items-center h-100'>
              <span
                className={`badge badge-light-${AppMapas.MAPA_PERFIL_USUARIO.get(
                  usuarioActual?.perfil!
                )} fw-bolder fs-7 px-2 py-1 ms-2`}>
                {usuarioActual?.descPerfil}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className='separator border-danger my-10'></div>
    </>
  )
}
